import React from 'react';
import Button from '../../../Button';
import { dateToFormat, now } from '../../../../utils/date';
import { viewLoading } from '../../../../utils/loading';



const TaxSingoItemDefault = (props) => {

  const { data, 
    // scheduled, 
    // taxpayerSingo, dataIdx, 
    openDataMemo, 
    onChange } = props


  const onChecked = (checkType) => {
    viewLoading(true)

    const checkTypes = {
      true: {
        value: now(),
        status: 'completed'
      },
      false: {
        value: null,
        status: 'pending'
      },
      pass: {
        value: null,
        status: 'cancelled'
      }
    }
    const currentCheckType = checkTypes[checkType]

    const updatedData = {
      ...data,
      ...currentCheckType
    }
    onChange(updatedData)
  }

  return <div className="tax-singo-item-box">
    <div className='tax-singo-item-value'>
      {data.value ? dateToFormat(data.value, 'MM.DD') : '-'}
    </div>
    <div className='tax-singo-item-drop-box'>
      <div className='tax-sing-item-drop-box-header'>
        {data.name}
      </div>
      <div className="tax-singo-item-bottom">
        {data.value ?
          <Button
            label={'취소'}
            size="tiny"
            color="danger"
            onClick={() => onChecked('false')}
          />
          :
          <Button
            label={'확인'}
            size="tiny"
            onClick={() => onChecked('true')}
          />
        }
        <Button
          label={'없음'}
          size="tiny"
          color="dark"
          onClick={() => onChecked('pass')}
        />
        <Button
          label={'메모'}
          size="tiny"
          color="info"
          onClick={() => openDataMemo(true)}
        />
      </div>
    </div>
  </div>
}

export default TaxSingoItemDefault